import { useState } from "react";
import CreateIcon from "../../Icons/Create";
import Spinner from "../../components/Reusable/Spinner";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePostHook from "../../customHooks/usePostHook";
import print from "print-js";

import loadable from "@loadable/component";
import useUserServiceGetHook from "../../customHooks/useUserServiceGetHook";
import usePDFPrintHook from "../../customHooks/usePDFPrintHook";

const CreateOrderComponent = loadable(
  () => import("../../components/Order/CreateOrder")
);
const CreateOrder = () => {
  const [openAddReceiverPopup, setOpenAddReceiverPopup] = useState(false)
  const [openAddSenderPopup, setOpenAddSenderPopup] = useState(false)
  const [openPrintPopup, setOpenPrintPopup] = useState(false)
  const [selectedOrder, setSelectedOrder] = useState(null)

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["order"],
    navigateURL: "",
  });

  const { mutateAsync: calculateDeliveryCharge, isPostLoading: isDeliveryChargeCalculating } = usePostHook({
    queryKey: [],
    navigateURL: "",
  });

  const { data: defaultBranch, isLoading } = useGetHook({
    queryKey: [`default-branch`],
    url: `${APIS.DEFAULT_BRANCH}`,
    params: {},
  });

  const { data: clientType, isLoading: clientTypeLoading } = useGetHook({
    queryKey: [`client-type`],
    url: `${APIS.CLIENT_TYPE}`,
    params: {},
  });

  const { data: profile } = useUserServiceGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });

  const { mutateAsync: downloadPrint, isPostLoading: isPrintLoading } = usePDFPrintHook({
    queryKey: [],
  });

  const handleLabelPrintDownload = async () => {

    const url = `${APIS.ORDER}label-print/`;
    let formData = {
      order_ids: [selectedOrder]
    };
    try {
      const res = await downloadPrint({ url, formData });
      const fileURL = URL.createObjectURL(res?.data);
      print(fileURL)
    } catch (err) {
      console.log(err);
    }
  }

  const handleOrderReceiptDownload = async () => {
    const url = `${APIS.ORDER}order-receipt-print/`;
    let formData = {
      order_ids: [selectedOrder]
    };
    try {
      const res = await downloadPrint({ url, formData });
      const fileURL = URL.createObjectURL(res?.data);
      print(fileURL)
    } catch (err) {
      console.log(err);
    }
  }

  const handleCreate = async (values: any, setError: any) => {
    console.log(values)
    const url = `${APIS.ORDER}`;
    let formData = {
      ...values
    }
    try {
      const res = await mutateAsync({ url, formData });
      if (res.status === 201) {
        setOpenPrintPopup(true)
        setSelectedOrder(res?.data?.id)
      }
    } catch (err) {
      console.log(err);
    }
  };

  const { mutateAsync: createCustomerMutateAsync, isPostLoading: createCustomerLoading } = usePostHook({
    queryKey: ["customers"],
    navigateURL: null,
  });

  const handleCreateCustomer = async (values: any, setError: any) => {
    const url = `${APIS.CUSTOMER}`;
    let formData = {
      ...values,
      "primary_contact": `+977${values?.mobile_number}`,
      "secondary_contact": values?.secondary_contact ? `+977${values?.secondary_contact}` : `+977${values?.mobile_number}`
    };
    try {
      const res = await createCustomerMutateAsync({ url, formData, setError });
      if (res.status === 201) {
        setOpenAddReceiverPopup(false)
        setOpenAddSenderPopup(false)
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Create Consignment</span>
      </div>
      {isLoading || clientTypeLoading ? <Spinner /> :
        <CreateOrderComponent
          isLoading={isPostLoading}
          handleCreate={handleCreate}
          handleCreateCustomer={handleCreateCustomer}
          createCustomerLoading={createCustomerLoading}
          defaultBranch={defaultBranch}
          openAddReceiverPopup={openAddReceiverPopup}
          setOpenAddReceiverPopup={setOpenAddReceiverPopup}
          openAddSenderPopup={openAddSenderPopup}
          setOpenAddSenderPopup={setOpenAddSenderPopup}
          openPrintPopup={openPrintPopup}
          setOpenPrintPopup={setOpenPrintPopup}
          profile={profile}
          handleLabelPrintDownload={handleLabelPrintDownload}
          handleOrderReceiptDownload={handleOrderReceiptDownload}
          isPrintLoading={isPrintLoading}
          clientType={clientType}
          calculateDeliveryCharge={calculateDeliveryCharge}
          isDeliveryChargeCalculating={isDeliveryChargeCalculating}
        />
      }

    </>
  );
};

export default CreateOrder;
